export const ACTION_TYPES = {
  LOGIN: {
    REQUEST: 'LOGIN_REQUEST',
    SUCCESS: 'LOGIN_SUCCESS',
    FAILURE: 'LOGIN_FAILURE'
  }
};



// WEBPACK FOOTER //
// ./src/pages/login/constants.js